import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FaBuilding } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaWifi } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { FaUserGroup } from "react-icons/fa6";
import { IoSave } from "react-icons/io5";
import { FaLightbulb } from "react-icons/fa6";
import { FaSearch } from "react-icons/fa";
import { MdOutlineEventNote } from "react-icons/md";
import { FaGlobe } from "react-icons/fa";
import { API_URL } from "../config";
import "../assets/css/Admin.css";

const API = `${API_URL}/api/admin`;

function Admin() {
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("entreprises");
  const [searchHeader, setSearchHeader] = useState("");
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [filtreStatut, setFiltreStatut] = useState("tous");
  const [stats, setStats] = useState({ totalEntreprises: 0, totalUtilisateurs: 0, totalVouchersActifs: 0 });

  const [entreprises, setEntreprises] = useState([]);
  const [entreprisesTotal, setEntreprisesTotal] = useState(0);
  const [entreprisesPage, setEntreprisesPage] = useState(1);
  const [entreprisesLimit, setEntreprisesLimit] = useState(10);
  const [entreprisesTotalPages, setEntreprisesTotalPages] = useState(1);

  const [utilisateurs, setUtilisateurs] = useState([]);
  const [utilisateursTotal, setUtilisateursTotal] = useState(0);
  const [utilisateursPage, setUtilisateursPage] = useState(1);
  const [utilisateursLimit, setUtilisateursLimit] = useState(10);
  const [utilisateursTotalPages, setUtilisateursTotalPages] = useState(1);

  
  const [sites, setSites] = useState([]);
  const [sitesTotal, setSitesTotal] = useState(0);
  const [sitesPage, setSitesPage] = useState(1);
  const [sitesLimit, setSitesLimit] = useState(10);
  const [sitesTotalPages, setSitesTotalPages] = useState(1);

  // Modals
  const [showEntrepriseModal, setShowEntrepriseModal] = useState(false);
  const [showUtilisateurModal, setShowUtilisateurModal] = useState(false);
  const [showSiteModal, setShowSiteModal] = useState(false);
  const [showSiteConfigModal, setShowSiteConfigModal] = useState(false); // configure site modal from entreprise
  const [editingEntreprise, setEditingEntreprise] = useState(null);
  const [editingUtilisateur, setEditingUtilisateur] = useState(null);
  const [editingSite, setEditingSite] = useState(null);


  const [entrepriseForm, setEntrepriseForm] = useState({ nomEntreprise: "", reference: "" });
  const [utilisateurForm, setUtilisateurForm] = useState({
    nom: "", prenom: "", email: "", password: "", roles: ["ROLE_USER"], entrepriseId: ""
  });
  
  const [siteForm, setSiteForm] = useState({
    label: "", siteUid: "", consoleId: "", entrepriseId: "",  apiKey: ""
  });

  const [vouchers, setVouchers] = useState([]);
  const [vouchersTotal, setVouchersTotal] = useState(0);
  const [vouchersPage, setVouchersPage] = useState(1);
  const [vouchersLimit, setVouchersLimit] = useState(10);
  const [vouchersTotalPages, setVouchersTotalPages] = useState(1);

  const [showHelp, setShowHelp] = useState(false);

 const authFetch = useCallback((url, options = {}) => {
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("Aucun token trouvé dans le localStorage");
        navigate("/");
        return Promise.reject("No token");
      }

      const headers = { 
        "Content-Type": "application/json",
        "Accept": "application/json", 
        "Authorization": `Bearer ${token}` 
      };

      return fetch(url, { 
        ...options, 
        headers: { ...headers, ...(options.headers || {}) } 
      });
    }, [navigate]); 

  const fetchAllVouchers = useCallback(async (page, limit, search, statut) => {
    try {
      const res = await authFetch(`${API}/vouchers?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
      if (res.ok) {
        const data = await res.json();
        setVouchers(data.data);
        setVouchersTotal(data.total);
        setVouchersTotalPages(data.totalPages);
      }
    } catch (error) {
      console.error("erreur fetchAllVouchers - Historique non trouvée ou erreur serveur.");
    }
  }, [authFetch]);

  useEffect(() => {
    if (activeMenu === "historique") {
      fetchAllVouchers(vouchersPage, vouchersLimit, searchHeader, filtreStatut);
    }
  }, [activeMenu, vouchersPage, vouchersLimit, searchHeader, fetchAllVouchers,filtreStatut]);


  const [siteConfigEntreprise, setSiteConfigEntreprise] = useState(null);
  const [unifiSites, setUnifiSites] = useState([]); // sites retrieved from Unifi
  const [unifiLoading, setUnifiLoading] = useState(false);

  const [entreprisesSelect, setEntreprisesSelect] = useState([]);

    const getUsername = () => {
    const token = localStorage.getItem("token");
    if (!token) return "Admin";
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(window.atob(base64));
      return payload.username || "Admin";
    } catch (e) {
      return "Admin";
    }
  };

    const handleLogout = useCallback(() => {
      localStorage.removeItem("token");
      navigate("/");
    }, [navigate]);

  const fetchStats = useCallback(async () => {
  try {
    const res = await authFetch(`${API}/stats`);
    if (res.ok) {
      setStats(await res.json());
    } else if (res.status === 401) {
      handleLogout();
    }
  } catch (error) {
    console.error("Erreur stats:", error);
  }
}, [authFetch, handleLogout]);

 
    const fetchEntreprises = useCallback(async (page, limit, search) => {
    try {
      const res = await authFetch(`${API}/entreprises?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
      
      if (res.ok) {
        const data = await res.json();
        setEntreprises(data.data);
        setEntreprisesTotal(data.total);
        setEntreprisesTotalPages(data.totalPages);
      } else if (res.status === 401) {
        handleLogout(); 
      }
    } catch (error) {
      console.error("Erreur fetchEntreprises:", error);
    }
  }, [authFetch, handleLogout]);

    const fetchUtilisateurs = useCallback(async (page, limit, search) => {
      try {
        const res = await authFetch(`${API}/utilisateurs?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
        if (res.ok) {
          const data = await res.json();
          setUtilisateurs(data.data);
          setUtilisateursTotal(data.total);
          setUtilisateursTotalPages(data.totalPages);
        } else if (res.status === 401) {
          handleLogout();
        }
      } catch (error) {
        console.error("Erreur fetchUtilisateurs:", error);
      }
    }, [authFetch, handleLogout]);

  const fetchSites = useCallback(async (page, limit, search) => {
    const res = await authFetch(`${API}/sites?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
    if (res.ok) {
      const data = await res.json();
      setSites(data.data);
      setSitesTotal(data.total);
      setSitesTotalPages(data.totalPages);
    }
  }, [authFetch]);

  const fetchEntreprisesSelect = useCallback(async () => {
    const res = await authFetch(`${API}/entreprises?page=1&limit=100`);
    if (res.ok) {
      const data = await res.json();
      setEntreprisesSelect(data.data);
    }
  }, [authFetch]);

  useEffect(() => { fetchStats(); }, [fetchStats]);

  useEffect(() => {
    if (activeMenu === "entreprises") fetchEntreprises(entreprisesPage, entreprisesLimit, searchHeader);
  }, [activeMenu, entreprisesPage, entreprisesLimit, searchHeader, fetchEntreprises]);

  useEffect(() => {
    if (activeMenu === "utilisateurs") fetchUtilisateurs(utilisateursPage, utilisateursLimit, searchHeader);
  }, [activeMenu, utilisateursPage, utilisateursLimit, searchHeader, fetchUtilisateurs]);

  useEffect(() => {
    if (activeMenu === "sites") fetchSites(sitesPage, sitesLimit, searchHeader);
  }, [activeMenu, sitesPage, sitesLimit, searchHeader, fetchSites]);

  const handleMenuChange = (menu) => {
    setActiveMenu(menu);
    setSearchHeader("");
    setEntreprisesPage(1);
    setUtilisateursPage(1);
    setSitesPage(1);
  };

  // Entreprise CRUD 
  const openCreateEntreprise = () => {
    setEditingEntreprise(null);
    setEntrepriseForm({ nomEntreprise: "", reference: "" });
    setShowEntrepriseModal(true);
  };

  const openEditEntreprise = (e) => {
    setEditingEntreprise(e);
    setEntrepriseForm({ nomEntreprise: e.nomEntreprise, reference: e.reference });
    setShowEntrepriseModal(true);
  };

  const saveEntreprise = async () => {
    if (!entrepriseForm.nomEntreprise || !entrepriseForm.reference) {
      alert("Veuillez remplir tous les champs."); return;
    }
    const url = editingEntreprise ? `${API}/entreprises/${editingEntreprise.id}` : `${API}/entreprises`;
    const method = editingEntreprise ? "PUT" : "POST";
    const res = await authFetch(url, { method, body: JSON.stringify(entrepriseForm) });
    if (res.ok) {
      setShowEntrepriseModal(false);
      fetchEntreprises(entreprisesPage, entreprisesLimit, searchHeader);
      fetchStats();
    } else {
      const err = await res.json();
      alert(err.error || "Erreur");
    }
  };

  const deleteEntreprise = async (id) => {
  if (!window.confirm("Supprimer cette entreprise ?")) return;

  const res = await authFetch(`${API}/entreprises/${id}`, { method: "DELETE" });
  if (res.ok) {
    fetchEntreprises(entreprisesPage, entreprisesLimit, searchHeader);
    fetchStats();
  } else {
    const err = await res.json();
  //  console.log("ERREUR SUPPRESSION =", err);
    alert(err.message || "Erreur suppression");
  }
};

  // Opens modal site configuration for a company
  const openSiteConfig = (entreprise) => {
    setSiteConfigEntreprise(entreprise);
    setSiteForm({ label: "", siteUid: "", consoleId: "", entrepriseId: entreprise.id, apiKey: "" });
    setUnifiSites([]);
    setShowSiteConfigModal(true);
  };

  // Retrieves UniFi sites using the entered consoleID
  const fetchUnifiSites = async () => {
    if (!siteForm.consoleId) { alert("Entrez d'abord un Console ID."); return; }
    if (!siteForm.apiKey)    { alert("Entrez d'abord la clé API."); return; }

    setUnifiLoading(true);
    try {
        const res = await authFetch(
        `${API}/sites/unifi/${siteForm.consoleId}?apiKey=${encodeURIComponent(siteForm.apiKey)}`
        );
        if (res.ok) {
        const data = await res.json();
        setUnifiSites(data.data || []);
        } else {
        const err = await res.json();
        alert(err.error || "Impossible de contacter le firewall. Vérifiez le Console ID et la clé API.");
        }
    } catch (e) {
        alert("Erreur réseau.");
    } finally {
        setUnifiLoading(false);
    }
};

  const saveSiteConfig = async () => {
    if (!siteForm.label || !siteForm.siteUid || !siteForm.consoleId) {
      alert("Veuillez remplir tous les champs."); return;
    }
   
   
    const res = await authFetch(`${API}/sites`, { method: "POST", body: JSON.stringify(siteForm) });

    if (res.ok) {
      setShowSiteConfigModal(false);
      alert("Site configuré avec succès !");
      fetchSites(sitesPage, sitesLimit, searchHeader);
    } else {
      const err = await res.json();
      alert(err.error || "Erreur");
    }
  };

  // Site CRUD
  const openCreateSite = () => {
    setEditingSite(null);
    setSiteForm({ label: "", siteUid: "", consoleId: "", entrepriseId: "", apiKey: "" });
    fetchEntreprisesSelect();
    setShowSiteModal(true);
  };

  const openEditSite = (s) => {
    setEditingSite(s);
    setSiteForm({ label: s.label, siteUid: s.siteUid, consoleId: s.consoleId, entrepriseId: s.entrepriseId });
    fetchEntreprisesSelect();
    setShowSiteModal(true);
  };

  const saveSite = async () => {
    const url = editingSite ? `${API}/sites/${editingSite.id}` : `${API}/sites`;
    const method = editingSite ? "PUT" : "POST";
    const res = await authFetch(url, { method, body: JSON.stringify(siteForm) });
    if (res.ok) {
      setShowSiteModal(false);
      fetchSites(sitesPage, sitesLimit, searchHeader);
    } else {
      const err = await res.json();
      alert(err.error || "Erreur");
    }
  };

  const deleteSite = async (id) => {
    if (!window.confirm("Supprimer ce site ?")) return;
    const res = await authFetch(`${API}/sites/${id}`, { method: "DELETE" });
    if (res.ok) fetchSites(sitesPage, sitesLimit, searchHeader);
    else alert("Erreur suppression");
  };

  // Utilisateur CRUD 
  const openCreateUtilisateur = () => {
    setEditingUtilisateur(null);
    setUtilisateurForm({ nom: "", prenom: "", email: "", password: "", roles: ["ROLE_USER"], entrepriseId: "" });
    fetchEntreprisesSelect();
    setShowUtilisateurModal(true);
  };

  const openEditUtilisateur = (u) => {
    setEditingUtilisateur(u);
    setUtilisateurForm({ nom: u.nomUtilisateur, prenom: u.prenomUtilisateur, email: u.email, password: "", roles: u.roles, entrepriseId: u.entrepriseId || "" });
    fetchEntreprisesSelect();
    setShowUtilisateurModal(true);
  };

  const saveUtilisateur = async () => {
    if (!utilisateurForm.nom || !utilisateurForm.prenom || !utilisateurForm.email) {
      alert("Veuillez remplir tous les champs obligatoires."); return;
    }
    const url = editingUtilisateur ? `${API}/utilisateurs/${editingUtilisateur.id}` : `${API}/utilisateurs`;
    const method = editingUtilisateur ? "PUT" : "POST";
    const body = { ...utilisateurForm };
    if (editingUtilisateur && !body.password) delete body.password;
    const res = await authFetch(url, { method, body: JSON.stringify(body) });
    if (res.ok) {
      setShowUtilisateurModal(false);
      fetchUtilisateurs(utilisateursPage, utilisateursLimit, searchHeader);
      fetchStats();
    } else {
      const err = await res.json();
      alert(err.error || "Erreur");
    }
  };

  const deleteUtilisateur = async (id) => {
    if (!window.confirm("Supprimer cet utilisateur ?")) return;
    const res = await authFetch(`${API}/utilisateurs/${id}`, { method: "DELETE" });
    if (res.ok) { fetchUtilisateurs(utilisateursPage, utilisateursLimit, searchHeader); fetchStats(); }
    else alert("Erreur suppression");
  };

  const getRoleBadge = (roles) => {
    if (roles.includes("ROLE_ADMIN")) return <span className="badge-admin">Administrateur</span>;
    return <span className="badge-user">Utilisateur</span>;
  };

  const truncate = (str, n = 20) => str && str.length > n ? str.substring(0, n) + "..." : str;

  const renderPagination = (currentPage, totalPages, setPage) => (
    <div className="pagination">
      <button className="page-btn" disabled={currentPage === 1} onClick={() => setPage(p => p - 1)}>‹</button>
      {Array.from({ length: totalPages }, (_, i) => i + 1)
        .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1)
        .map((p, i, arr) => (
          <span key={p}>
            {i > 0 && arr[i - 1] !== p - 1 && <span className="dots">…</span>}
            <button className={currentPage === p ? "page-btn active" : "page-btn"} onClick={() => setPage(p)}>{p}</button>
          </span>
        ))}
      <button className="page-btn" disabled={currentPage >= totalPages} onClick={() => setPage(p => p + 1)}>›</button>
    </div>
  );

  //console.log("Voucher 0:", vouchers[0]);

  const  filteredVouchers = vouchers.filter((v) => {
    const dateCreation = new Date(v.dateCreation);
    const diffJours = (new Date() - dateCreation) / (1000 * 60 * 60 * 24);
    
    const estVraimentDisponible = v.estActif && !v.utilise && diffJours <= 30;
    const estEnCours = v.estActif && v.utilise;
    const estExpire = !v.estActif || (v.estActif && !v.utilise && diffJours > 30);

    if (filtreStatut === "disponible") return estVraimentDisponible;
    if (filtreStatut === "utilise") return estEnCours;
    if (filtreStatut === "expire") return estExpire;
    return true;
  });


  return (
    <div className="admin-layout" onClick={() => showUserMenu && setShowUserMenu(false)}>

      {/* SIDEBAR */}
      <aside className="admin-sidebar">
        <div className="sidebar-brand">
          <div className="sidebar-brand-title"> ESPACE ADMIN </div>
        </div>

        <nav className="sidebar-nav">
         
          <button className={`sidebar-item ${activeMenu === "entreprises" ? "active" : ""}`}
            onClick={() => handleMenuChange("entreprises")}>
            <span className="sidebar-icon"> <FaBuilding /></span> Entreprises 
          </button>

          <button className={`sidebar-item ${activeMenu === "utilisateurs" ? "active" : ""}`}
            onClick={() => handleMenuChange("utilisateurs")}>
            <span className="sidebar-icon"><FaUser /></span> Utilisateurs
          </button>

          <button className={`sidebar-item ${activeMenu === "sites" ? "active" : ""}`}
            onClick={() => handleMenuChange("sites")}>
            <span className="sidebar-icon"><FaGlobe /></span>  Sites
          </button>

          <button className={`sidebar-item ${activeMenu === "historique" ? "active" : ""}`}
            onClick={() => handleMenuChange("historique")}>
            <span className="sidebar-icon"><MdOutlineEventNote /></span> Historique
          </button>
        </nav>

            {/* Bouton New Request 
           <div className="sidebar-footer">
           <button className="sidebar-item sidebar-new-request" onClick={() => navigate("/wifi-form")}>
            <span className="sidebar-icon">➕</span> New Request
          </button>
        </div> */ }

      </aside>

      {/* MAIN  */}
      <div className="admin-main">

        {/* Header */}
        <header className="admin-header">
          <input type="text" className="header-search"
            placeholder={
    
              activeMenu === "entreprises" ? "Rechercher une entreprise..." :
              activeMenu === "utilisateurs" ? "Rechercher un utilisateur..." :
              activeMenu === "sites" ? "Rechercher un site..." : "Rechercher..."
            }
            value={searchHeader}
            onChange={(e) => { setSearchHeader(e.target.value); setEntreprisesPage(1); setUtilisateursPage(1); setSitesPage(1); }}
          />
        

         <div  className="header-user" onClick={(e) => {  e.stopPropagation();
            setShowUserMenu(!showUserMenu); }}
        >
        <div className="header-avatar">
            {getUsername().charAt(0).toUpperCase()}
        </div>

        {showUserMenu && (
            <div className="user-dropdown">
        
            <div className="user-email-box">
                {getUsername()}
            </div>

            <button
                className="user-dropdown-item logout-item"
                onClick={handleLogout}
            >
                Se déconnecter
            </button>

            </div>
        )}
        </div>
        </header>

        {/* PAGE ENTREPRISES */}
        {activeMenu === "entreprises" && (
          <div className="admin-content">
            <div className="page-header">
              <div>
                <h1 className="page-title">Gestion des entreprises</h1>
              </div>
              <button className="btn-primary" onClick={openCreateEntreprise}>
                + Ajouter une entreprise
              </button>
            </div>

            <div className="stats-row">
              <div className="stat-card">
                <div className="stat-icon"><FaBuilding /></div>
                <div>
                  <div className="stat-label">Total des entreprises</div>
                  <div className="stat-valueTotalEntreprises">{stats.totalEntreprises}</div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon"> <FaWifi /> </div>
                <div>
                  <div className="stat-label">Accès Wifi actifs</div>
                  <div className="stat-valueTotalWifiActif">{stats.totalVouchersActifs}</div>
                </div>
              </div>
            </div>

            <div className="table-card">
              <div className="table-card-header">
                <span className="table-card-title">Toutes les entreprises</span>
                <div className="table-controls">
                  <select className="limit-select" value={entreprisesLimit}
                    onChange={(e) => { setEntreprisesLimit(Number(e.target.value)); setEntreprisesPage(1); }}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                  </select>
                </div>
              </div>
              

              <table className="admin-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nom d'entreprise</th>
                    <th>Référence</th>
                    <th>Utilisateurs</th>
                    <th>Vouchers</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {entreprises.length === 0 ? (
                    <tr><td colSpan="6" className="empty-row">Aucune entreprise</td></tr>
                  ) : entreprises.map((ent) => (
                    <tr key={ent.id}>
                      <td className="text-muted">#{ent.id}</td>
                      <td><strong>{ent.nomEntreprise}</strong></td>
                      <td className="text-muted">{ent.reference}</td>
                      <td>{ent.nbUtilisateurs}</td>
                      <td>{ent.nbVouchers}</td>
                      <td>
                        <div className="action-buttons">

                        <button className="btn-icon btn-edit" onClick={() => openEditEntreprise(ent)}> <FaPencil color="#0e47f1" size={14}/> </button>
                        <button className="btn-icon btn-site" onClick={(e) => { e.stopPropagation(); openSiteConfig(ent); }}><FaGlobe /></button>
                        <button className="btn-icon btn-del" onClick={() => deleteEntreprise(ent.id)}> < FaTrashAlt  color="#f10e0e" size={14}/> </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="table-footer">
                <span className="showing-text">{entreprises.length} / {entreprisesTotal} entreprises</span>
                {renderPagination(entreprisesPage, entreprisesTotalPages, setEntreprisesPage)}
              </div>
            </div>
          </div>
        )}

        {/*  PAGE UTILISATEURS  */}
        {activeMenu === "utilisateurs" && (
          <div className="admin-content">
            <div className="page-header">
              <h1 className="page-title">Gestion des utilisateurs</h1>
              <button className="btn-primary" onClick={openCreateUtilisateur}>+ Ajouter un utilisateur</button>
            </div>

            <div className="stats-row">
              <div className="stat-card">
                <div className="stat-icon"> <FaUserGroup/> </div>
                <div>
                  <div className="stat-label">Total des utilisateurs</div>
                  <div className="stat-valueTotalUser">{stats.totalUtilisateurs}</div>
                </div>
              </div>
            </div>

            <div className="table-card">
              <div className="table-card-header">
                <span className="table-card-title">Tous les utilisateurs <span className="badge-count">{utilisateursTotal} Total</span></span>
                <select className="limit-select" value={utilisateursLimit}
                  onChange={(e) => { setUtilisateursLimit(Number(e.target.value)); setUtilisateursPage(1); }}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                </select>
              </div>

              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Utilisateur</th>
                    <th>Rôle</th>
                    <th>Entreprise</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {utilisateurs.length === 0 ? (
                    <tr><td colSpan="4" className="empty-row">Aucun utilisateur</td></tr>
                  ) : utilisateurs.map((u) => (
                    <tr key={u.id}>
                      <td>
                        <div className="user-cell">
                            
                          <div className="user-avatar">{u.nomUtilisateur.charAt(0)}</div>
                          <div>
                            <div className="user-name">{u.prenomUtilisateur} {u.nomUtilisateur.toUpperCase()}</div>
                            <div className="user-email">{u.email}</div> 
                          </div>

                        </div>
                      </td>
                      <td>{getRoleBadge(u.roles)}</td>
                      <td className="text-muted">{u.entreprise || "—"}</td>
                      <td>
                        <div className="action-buttons">
                          <button className="btn-icon btn-edit" onClick={() => openEditUtilisateur(u)}> <FaPencil color="#0e47f1" size={14}/> </button>
                          <button className="btn-icon btn-del" onClick={() => deleteUtilisateur(u.id)}> <FaTrashAlt color="#f10e0e" size={14}/> </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="table-footer">
                <span className="showing-text">
                  {((utilisateursPage - 1) * utilisateursLimit) + 1}–{Math.min(utilisateursPage * utilisateursLimit, utilisateursTotal)} sur {utilisateursTotal}
                </span>
                {renderPagination(utilisateursPage, utilisateursTotalPages, setUtilisateursPage)}
              </div>
            </div>
          </div>
        )}

        {/*  PAGE SITES  */}
        {activeMenu === "sites" && (
          <div className="admin-content">
            <div className="page-header">
              <h1 className="page-title">Gestion des sites</h1>
              <button className="btn-primary" onClick={openCreateSite}>+ Ajouter un site</button>
            </div>

            <div className="stats-row">
              <div className="stat-card">
                <div className="stat-icon"><FaGlobe color="#0e47f1" /></div>
                <div>
                  <div className="stat-label">TOTAL DES SITES CONFIGURÉS</div>
                  <div className="stat-valueTotalEntreprises">{sitesTotal}</div>
                </div>
              </div>
            </div>

            <div className="table-card">
              <div className="table-card-header">
                <span className="table-card-title">Tous les sites <span className="badge-count">{sitesTotal} Total</span></span>
                <select className="limit-select" value={sitesLimit}
                  onChange={(e) => { setSitesLimit(Number(e.target.value)); setSitesPage(1); }}>
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                </select>
              </div>

              <table className="admin-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Entreprise</th>
                    <th>Label</th>
                    <th>Site UID</th>
                    <th>Console ID</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {sites.length === 0 ? (
                    <tr><td colSpan="6" className="empty-row">Aucun site configuré</td></tr>
                  ) : sites.map((s) => (
                    <tr key={s.id}>
                      <td className="text-muted">#{s.id}</td>
                      <td><strong>{s.nomEntreprise}</strong></td>
                      <td>{s.label}</td>
                      <td><span className="code-inline" title={s.siteUid}>{truncate(s.siteUid, 18)}</span></td>
                      <td><span className="code-inline" title={s.consoleId}>{truncate(s.consoleId, 18)}</span></td>

                      <td>
                        <div className="action-buttons">
                          <button className="btn-icon btn-edit" onClick={() => openEditSite(s)}> <FaPencil color="#0e47f1" size={16}/> </button>
                          <button className="btn-icon btn-del" onClick={() => deleteSite(s.id)}> <FaTrashAlt  color="#ff0000" size={16} /> </button>
                        </div>
                      </td>

                    </tr>
                  ))} 
                </tbody>
              </table>

              <div className="table-footer">
                <span className="showing-text">{sites.length} / {sitesTotal} sites</span>
                {renderPagination(sitesPage, sitesTotalPages, setSitesPage)}
              </div>
            </div>
          </div>
        )}


        {/* PAGE HISTORIQUE GLOBALE */}
        {activeMenu === "historique" && (
          <div className="admin-content">
            <div className="page-header">
              <h1 className="page-title">Historique des accès WiFi</h1>
            </div>

            <div className="stats-row">
              <div className="stat-card">
                <div className="stat-icon"><FaWifi color="#0e47f1" /></div>
                <div>
                  <div className="stat-label">NOMBRE TOTAL DE VOUCHER ( Accès Wifi )</div>
                  <div className="stat-valueTotalEntreprises">{vouchersTotal}</div>
                </div>
              </div>
            </div>

            <div className="table-card">
             <div className="table-card-header">


  <span className="table-card-title">Tous les accès générés</span>
  
         <div className="table-controls">

          <select 
              className="filter-select" 
              value={filtreStatut} 
              onChange={(e) => setFiltreStatut(e.target.value)}
            >
                <option value="tous">Tous les statuts</option>
                <option value="disponible">Disponible (Non activé)</option>
                <option value="utilise">Utilisé / En cours</option>
                <option value="expire">Expiré</option>
            </select>

            <select 
              className="limit-select" 
              value={vouchersLimit}
              onChange={(e) => { setVouchersLimit(Number(e.target.value)); setVouchersPage(1); }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>

              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Nom Entreprise</th>
                    <th>Date de création</th>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>Clé</th>
                    <th>Expiration</th>
                    <th>Statut</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredVouchers.length === 0 ? (
                    <tr><td colSpan="7" className="empty-row">Aucun voucher trouvé</td></tr>
                  ) : filteredVouchers.map((v) => (
                    <tr key={v.id}>
                      <td><strong>{v.nomEntreprise}</strong></td>
                      <td className="text-muted">{new Date(v.dateCreation).toLocaleDateString('fr-FR')}</td>
                      <td>{v.nom}</td>
                      <td>{v.prenom}</td>
                      <td><span className="badge-code">{v.code}</span></td>

                     <td>
                        {(() => {
                          // 1. If the voucher is AVAILABLE (Active and unused)
                          if (v.estActif && !v.utilise) {
                            const dateCreation = new Date(v.dateCreation);
                            const mtn = new Date();
                            const joursEcoules = Math.floor((mtn - dateCreation) / (1000 * 60 * 60 * 24));
                            const joursRestants = 30 - joursEcoules;

                            return (
                              <span style={{ color: '#f39c12', fontWeight: '500' }}>
                                À activer sous {joursRestants > 0 ? joursRestants : 0} j
                              </span>
                            );
                          }

                          // 2. If the voucher is EXPIRED but has NEVER been used (no expiry date)
                          if (!v.utilise && !v.dateExpiration) {
                            return <span className="text-muted">Jamais activé</span>;
                          }

                          // 3. If the voucher is USED or EXPIRED with a valid date
                          const dateExp = new Date(v.dateExpiration);
                          
                          // Checking if the date is valid before displaying it
                          if (isNaN(dateExp.getTime())) {
                            return <span className="text-muted">—</span>;
                          }

                          return dateExp.toLocaleDateString('fr-FR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          });
                        })()}
                     </td>

                  <td>
                    {(() => {
                      // 1. Already disabled (Cron)
                      if (!v.estActif) return <span className="status-expired">Expiré</span>;

                      // 2. Not yet activated
                      if (!v.utilise) {
                        const diffJours = (new Date() - new Date(v.dateCreation)) / (1000 * 60 * 60 * 24);
                        return diffJours > 30 
                          ? <span className="badge-expire">Expiré (Non activé)</span>
                          : <span  className="badge-disponible" >Disponible</span>;
                      }

                      // 3. Used
                      return (
                        <span className="badge-utilise" >
                          Utilisé / En cours
                        </span>
                      );
                    })()}
                  </td>   
              </tr>
                  ))}
                </tbody>
              </table>

              <div className="table-footer">
                <span className="showing-text">{vouchers.length} / {vouchersTotal} vouchers</span>
                {renderPagination(vouchersPage, vouchersTotalPages, setVouchersPage)}
              </div>
            </div>
  </div>
)}
      </div>

      {/* MODAL ENTREPRISE */}
      {showEntrepriseModal && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowEntrepriseModal(false)}>
          <div className="modal-box">
            <h2 className="modal-title">{editingEntreprise ? "Modifier l'entreprise" : "Ajouter une entreprise"}</h2>
          
            <label className="form-label">Nom de l'entreprise *</label>
            <input className="form-input" value={entrepriseForm.nomEntreprise}
              onChange={(e) => setEntrepriseForm({ ...entrepriseForm, nomEntreprise: e.target.value })}
              placeholder="Ex: Hôtel Azur" />

            <label className="form-label">Référence *</label>
            <input className="form-input" value={entrepriseForm.reference}
              onChange={(e) => setEntrepriseForm({ ...entrepriseForm, reference: e.target.value })}
              placeholder="Ex: HOTEL-001" />

            <div className="modal-actions">
              <button className="btn-secondary" onClick={() => setShowEntrepriseModal(false)}>Annuler</button>
              <button className="btn-primary" onClick={saveEntreprise}>{editingEntreprise ? "Enregistrer" : "Créer"}</button>
            </div>
          </div>
        </div>
      )}

      {/*MODAL CONFIGURER SITE (depuis bouton dans tableau entreprises) */}
      {showSiteConfigModal && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowSiteConfigModal(false)}>
            <div className="modal-box modal-wide">
            <h2 className="modal-title"><FaGlobe /> Configurer le site — {siteConfigEntreprise?.nomEntreprise}</h2>
            <label className="form-label">Clé API Unifi *</label>
            <input
                className="form-input"
                value={siteForm.apiKey}
                onChange={(e) => setSiteForm({ ...siteForm, apiKey: e.target.value })}
                placeholder="Ex: TmBvk8gi4h59Jx..."
                type="password"
            />
            <p className="field-hint">Votre clé API personnelle depuis l'interface Unifi.</p>

            <label className="form-label" style={{marginTop: "12px"}}>Console ID *</label>
            <div className="input-with-btn">
                <input
                className="form-input"
                value={siteForm.consoleId}
                onChange={(e) => setSiteForm({ ...siteForm, consoleId: e.target.value })}
                placeholder="Ex: 0CEA1412069D..."
                />
                <button className="btn-fetch" onClick={fetchUnifiSites} disabled={unifiLoading}>
               <FaSearch/> {unifiLoading ? "..." : " Récupérer sites"}
                </button>
            </div>

            {unifiSites.length > 0 && (
                <div className="unifi-sites">
                <p className="form-label" style={{marginTop: "12px"}}>Sites trouvés — cliquez pour sélectionner :</p>
                {unifiSites.map((us) => (
                    <button key={us.id}
                    className={`unifi-site-btn ${siteForm.siteUid === us.id ? "selected" : ""}`}
                   /* onClick={() => setSiteForm({ ...siteForm, siteUid: us.id, label: us.name || siteForm.label })}>*/
                   onClick={() => setSiteForm(prev => ({ ...prev, siteUid: us.id, label: us.name || prev.label }))}>
                    <strong>{us.name}</strong> <span className="text-muted">— {us.id}</span>
                    </button>
                ))}
                </div>
            )}

            <label className="form-label" style={{marginTop: "12px"}}>Label (emplacement) *</label>
            <input className="form-input" value={siteForm.label}
                onChange={(e) => setSiteForm({ ...siteForm, label: e.target.value })}
                placeholder="Ex: Paris - Siège" />

            <label className="form-label">Site UID *</label>
            <input className="form-input" value={siteForm.siteUid}
                onChange={(e) => setSiteForm({ ...siteForm, siteUid: e.target.value })}
                placeholder="Ex: 88f7af54-98f8-..." />

            <div className="modal-actions">
                <button className="btn-secondary" onClick={() => setShowSiteConfigModal(false)}>Annuler</button>
                <button className="btn-primary" onClick={saveSiteConfig}> <IoSave/> Enregistrer en BDD</button>
            </div>
            </div>
        </div>
)}

      {/* MODAL SITE (from the sites page)*/}
      {showSiteModal && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowSiteModal(false)}>
          <div className="modal-box modal-wide">
          
            <h2 className="modal-title">{editingSite ? "Modifier le site" : "Ajouter un site"}</h2>
            
            <label className="form-label">Entreprise *</label>
            <select className="form-input" value={siteForm.entrepriseId}
              onChange={(e) => setSiteForm({ ...siteForm, entrepriseId: e.target.value })}>
              <option value="">-- Choisir une entreprise --</option>
              {entreprisesSelect.map((e) => (
                <option key={e.id} value={e.id}>{e.nomEntreprise} ({e.reference})</option>
              ))}
            </select>

            <label className="form-label">Label *</label>
            <input className="form-input" value={siteForm.label}
              onChange={(e) => setSiteForm({ ...siteForm, label: e.target.value })}
              placeholder="Ex: Paris - Siège" />

            <label className="form-label">Console ID *</label>
            <input className="form-input" value={siteForm.consoleId}
              onChange={(e) => setSiteForm({ ...siteForm, consoleId: e.target.value })}
              placeholder="ConsoleID Unifi" />

            <label className="form-label">Site UID *</label>
            <input className="form-input" value={siteForm.siteUid}
              onChange={(e) => setSiteForm({ ...siteForm, siteUid: e.target.value })}
              placeholder="SiteUID Unifi" />

            <div className="modal-actions">
              <button className="btn-secondary" onClick={() => setShowSiteModal(false)}>Annuler</button>
              <button className="btn-primary" onClick={saveSite}>{editingSite ? "Enregistrer" : "Créer"}</button>
            </div>

          </div>
        </div>
      )}

      {/*  MODAL UTILISATEUR */}
      {showUtilisateurModal && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowUtilisateurModal(false)}>
          <div className="modal-box">
            <h2 className="modal-title">{editingUtilisateur ? "Modifier l'utilisateur" : "Ajouter un utilisateur"}</h2>
           
            <div className="form-row">
              <div>
                <label className="form-label">Nom *</label>
                <input className="form-input" value={utilisateurForm.nom}
                  onChange={(e) => setUtilisateurForm({ ...utilisateurForm, nom: e.target.value })} />
              </div>

              <div>
                <label className="form-label">Prénom *</label>
                <input className="form-input" value={utilisateurForm.prenom}
                  onChange={(e) => setUtilisateurForm({ ...utilisateurForm, prenom: e.target.value })} />
              </div>
            </div>

            <label className="form-label">Email *</label>
            <input className="form-input" type="email" value={utilisateurForm.email}
              onChange={(e) => setUtilisateurForm({ ...utilisateurForm, email: e.target.value })} />
            <label className="form-label">{editingUtilisateur ? "Nouveau mot de passe (vide = inchangé)" : "Mot de passe *"}</label>
            <input className="form-input" type="password" value={utilisateurForm.password}
              onChange={(e) => setUtilisateurForm({ ...utilisateurForm, password: e.target.value })} />
          
          
            <label className="form-label">Rôle</label>
            <select className="form-input"
              value={utilisateurForm.roles.includes("ROLE_ADMIN") ? "ROLE_ADMIN" : "ROLE_USER"}
              onChange={(e) => setUtilisateurForm({ ...utilisateurForm, roles: [e.target.value] })}>
              <option value="ROLE_USER">Utilisateur</option>
              <option value="ROLE_ADMIN">Administrateur</option>
            </select>


            <label className="form-label">Entreprise *</label>
            <select className="form-input" value={utilisateurForm.entrepriseId}
              onChange={(e) => setUtilisateurForm({ ...utilisateurForm, entrepriseId: e.target.value })}>
              <option value="">-- Choisir une entreprise --</option>
              {entreprisesSelect.map((e) => (
                <option key={e.id} value={e.id}>{e.nomEntreprise} ({e.reference})</option>
              ))}
            </select>

            <div className="modal-actions">
              <button className="btn-secondary" onClick={() => setShowUtilisateurModal(false)}>Annuler</button>
              <button className="btn-primary" onClick={saveUtilisateur}>{editingUtilisateur ? "Enregistrer" : "Créer"}</button>
            </div>
          </div>
        </div>
      )}

      {/* Help icon with status information visible only on the history tab */}
      {activeMenu === "historique" && (
        <div className="help-container">
          <button 
            className="help-button small" 
            onClick={() => setShowHelp(!showHelp)} 
            title="Aide sur les statuts"
          >
            <FaLightbulb />
          </button>

          {showHelp && (
            <div className="help-popup">
              <h4>Légende des statuts</h4>
              <ul>
                <li><span className="dot disponible"></span> <strong>Disponible :</strong> Code d'accès Wifi créé, pas encore utilisé.</li>
                <li><span className="dot utilise"></span> <strong>Utilisé :</strong> En cours d'utilisation (décompte expiration commencé).</li>
                <li><span className="dot expire"></span> <strong>Expiré :</strong> Code d'accès Wifi ayant atteint sa date d'expiration ou non utilisé après 30 jours.</li>
              </ul>
              <button className="help-close" onClick={() => setShowHelp(false)}>Fermer</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Admin;